import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider, AuthCallback } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import LivePage from "@/pages/LivePage";
import DonatePage from "@/pages/DonatePage";
import VaultHomePage from "@/pages/VaultHomePage";
import ChampionshipsPage from "@/pages/ChampionshipsPage";
import CoachEraPage from "@/pages/CoachEraPage";
import SeasonPage from "@/pages/SeasonPage";
import VideoPlayerPage from "@/pages/VideoPlayerPage";
import DocumentariesPage from "@/pages/DocumentariesPage";
import TBTPage from "@/pages/TBTPage";
import FootballPage from "@/pages/FootballPage";
import AdminPage from "@/pages/AdminPage";

const AppRouter = () => {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route
        path="*"
        element={
          <>
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/live" element={<LivePage />} />
                <Route path="/vault" element={<VaultHomePage />} />
                <Route path="/vault/era/:eraId" element={<CoachEraPage />} />
                <Route path="/vault/documentaries" element={<DocumentariesPage />} />
                <Route path="/vault/tbt" element={<TBTPage />} />
                <Route path="/vault/football" element={<FootballPage />} />
                <Route path="/season/:seasonId" element={<SeasonPage />} />
                <Route path="/watch/:videoId" element={<VideoPlayerPage />} />
                <Route path="/championships" element={<ChampionshipsPage />} />
                <Route path="/donate" element={<DonatePage />} />
              </Routes>
            </main>
            <Footer />
          </>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
